import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

// Components
import ProductPromotionCartItem from "./ProductPromotionCartItem";
import Text from "../Text";

// Selectors
import promotionSelectors from "../../store/promotion/selectors";

// Types
import Product from "../../store/product/model";

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const FreeGiftTitle = styled.h3<{ $topMargin?: boolean }>`
  position: relative;
  z-index: 10;
  margin: -1px 0 0 0;
  color: var(--indigo-blue-60);
  background-color: var(--white);
  display: flex;
  align-items: center;
  margin-top: ${(props) => (props.$topMargin ? "var(--spacing-0_5)" : "-1px")};

  span.title-text {
    flex: 0 0 auto;
    padding-right: var(--spacing-0_5);
  }

  span.title-line {
    width: 100%;
    flex: 1 1 auto;
    border-top: 1px solid var(--cool-40);
  }
`;

interface ProductPromotionCartItemsProps {
  isFlyoutContext: boolean;
  simplified: boolean;
  appliedProductPromotionProductsOverride?: Product[];
  topMargin?: boolean;
}

function ProductPromotionCartItems({
  isFlyoutContext,
  simplified,
  appliedProductPromotionProductsOverride,
  topMargin = false,
}: ProductPromotionCartItemsProps) {
  const activeAppliedProductPromotionProducts = useSelector(
    promotionSelectors.appliedProductPromotionProducts,
  );
  
  const products =
    appliedProductPromotionProductsOverride ||
    activeAppliedProductPromotionProducts;

  if (!products || products.length === 0) {
    return null;
  }

  return (
    <Container>
      <FreeGiftTitle className="typography-caption" $topMargin={topMargin}>
        <span className="title-text">
          <Text
            id="product.promotions.free-gift"
            defaultMessage="Free Gift"
          />
        </span>
        <span className="title-line" />
      </FreeGiftTitle>
      {products.map((product: Product, index: number) => {
        const lastItem = index === products.length - 1;
        return (
          <ProductPromotionCartItem
            key={`${product.id}-${index}`}
            isFlyoutContext={isFlyoutContext}
            simplified={simplified}
            appliedProductPromotionProductOverride={product}
            hideHeader={true}
            isLastItem={lastItem}
          />
        );
      })}
    </Container>
  );
}

export default ProductPromotionCartItems;
